import {SettingParam, ActionVariable} from "@/types/node";
import {useEffect, useState} from "react";
import JsonEditor from "../ui/JsonEditor";
import {formatJsonValue} from "@/utils/jsonHelper";
import {useValidation} from "@/utils/validation";
export interface Variable {
  key: string;
  value: string;
  id: string;
}

export const SettingJson = ({
  param,
  handleChange,
  selectedNodeId,
  disabled = false,
}: {
  param: SettingParam;
  handleChange: (param: SettingParam, value: string) => void;
  selectedNodeId: string;
  disabled: boolean;
}) => {
  const [value, setValue] = useState(param.value || "");

  useEffect(() => {
    if (param.value !== value) {
      setValue(param.value || "");
    }
  }, [param, selectedNodeId]);

  const {error, validate} = useValidation(param.validationSchema as any);
  const variables = [];

  return (
    <>
      <JsonEditor
        value={value as string}
        onChange={value => {
          setValue(formatJsonValue(value));
          validate(value);
          handleChange(param, value);
        }}
        variables={variables as unknown as ActionVariable[][]}
        disabled={disabled}
      />
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </>
  );
};
